<template>
	<div>
		<div class="card border-primary mb-3" v-if="model">
			<div class="card-body">
				<div class="row">
					<div class="col-md-12 col-lg-5 border-right">
						<div class="form-group text-center">
							<span>
								<i class="fas fa-calendar-week fa-2x mr-2"></i>
								<span class="h3">{{model.title}}</span>
							</span>
						</div>
						<div class="form-row">
							<div class="form-group col-md-6 col-sm-12">
								<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.venue') }}</label>
								<div>
									<span>{{isEnVersion ? model.placeNameEn : model.placeName}}</span>
								</div>
							</div>

							<div class="form-group col-md-6 col-sm-12">
								<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.hall') }}</label>
								<div>
									<span>{{isEnVersion ? model.hallNameEn : model.hallName}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12 col-lg-7">
						<div class="form-group" v-if="!model.isAllDay">
							<DateTimeRange
								:required="false"
								:startTime="model.startTime"
								:endTime="model.endTime"
                                :use-utc-time="true"
								:showTime="true"
								:startTitle="'scheduler.gridHeaders.startDate'"
								:endTitle="'scheduler.gridHeaders.endDate'"
								:readonly="true"
							></DateTimeRange>
						</div>
						<div class="form-group" v-else>
							<DateRange
								:required="false"
								:startTime="model.startTime"
								:endTime="model.endTime"
								:showTime="false"
								:startTitle="'scheduler.gridHeaders.startDate'"
								:endTitle="'scheduler.gridHeaders.endDate'"
								:readonly="true"
							></DateRange>
						</div>

						<div>
							<button
								class="btn btn-link btn-primary ml-0 pl-0"
								data-toggle="collapse"
								:href="'#hallEventDetailsCollapse' + _uid"
								role="button"
								aria-expanded="false"
								aria-controls="hallEventDetailsCollapse"
							>{{ $t('buttons.details.btnText')}}</button>
						</div>

						<div class="col-12 collapse" :id="'hallEventDetailsCollapse' + _uid">
							<div class="row">
								<div class="form-group col-md-6 col-sm-12">
									<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.title') }}</label>
									<div>
										<span>{{model.title}}</span>
									</div>
								</div>

								<div class="form-group col-md-6 col-sm-12">
									<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.description') }}</label>
									<div>
										<span>{{model.description}}</span>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="form-group col-md-6 col-sm-12">
									<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.gridHeaders.eventName') }}</label>
									<div>
										<span>{{model.eventName}}</span>
									</div>
								</div>

								<div class="form-group col-md-6 col-sm-12 d-flex justify-content-start">
									<label class="font-weight-bold" :for="'syncedWithMoodle' + _uid"></label>
									<vs-checkbox v-model="model.isAllDay" :disabled="true" :name="'isAllDay' + _uid" :id="'isAllDay' + _uid">{{ $t('scheduler.isAllDay') }}</vs-checkbox>
								</div>
							</div>

							<!--<div class="row">
                                <div class="form-group col-md-6 col-sm-12">
                                    <label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.venue') }}</label>
                                    <div>
                                        <span>{{isEnVersion ? model.placeNameEn : model.placeName}}</span>
                                    </div>
                                </div>

                                <div class="form-group col-md-6 col-sm-12">
                                    <label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.hall') }}</label>
                                    <div>
                                        <span>{{isEnVersion ? model.hallNameEn : model.hallName}}</span>
                                    </div>
                                </div>
							</div>-->

							<div class="row">
								<div class="form-group col-md-6 col-sm-12">
									<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.lecturers') }}</label>
									<div v-if="model.lecturersNamesList">
										<span class="badge badge-light" v-for="(item, index) in model.lecturersNamesList" :key="index">{{item}}</span>
									</div>
								</div>

								<div class="form-group col-md-6 col-sm-12">
									<label class="col-form-label font-weight-bold" for="title">{{ $t('scheduler.coordinators') }}</label>
									<div v-if="model.coordinatorsNamesList">
										<span class="badge badge-light" v-for="(item, index) in model.coordinatorsNamesList" :key="index">{{item}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-footer text-right" v-if="!hideBtns">
				<div class="btn-group" role="group" aria-label="Hall event buttons">
					<button v-if="allowEdit" type="button" class="btn btn-success" @click.stop="onEdit">
						<i class="fas fa-edit mr-2"></i>
						{{ $t('buttons.edit.btnText')}}
					</button>
					<button v-if="allowDelete" type="button" class="btn btn-danger" @click.stop="onDelete">
						<i class="fas fa-trash-alt mr-2"></i>
						{{ $t('buttons.delete.btnText')}}
					</button>
					<button v-if="!hideCloseBtn" type="button" class="btn btn-danger" @click.stop="onCancel">
						<i class="fas fa-times mr-2"></i>
						{{ $t('buttons.close')}}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ScheduleTask } from '../../models/models';
import { Culture } from '../../models/enums';
import DateTimeRange from '../../components/dateTimeRange/DateTimeRange';
import DateRange from '../../components/dateTimeRange/DateRange';

export default {
	props: {
		value: {
			type: [ScheduleTask, Object],
			required: false
		},
		allowEdit: {
			type: Boolean,
			required: false
		},
		allowDelete: {
			type: Boolean,
			required: false
		},
		hideBtns: {
			type: Boolean,
			required: false
		},
		hideCloseBtn: {
			type: Boolean,
			required: false
		}
	},
	components: {
		DateTimeRange,
		DateRange
	},
	data() {
		return {
			model: this.value
		};
	},
	mounted() {},
	methods: {
		onEdit() {
			if (this.allowEdit) {
				this.$emit('onHallEventEdit', this.model);
			}
		},
		onDelete() {
			if (this.allowDelete) {
				this.$emit('onHallEventDelete', this.model);
			}
		},
		onCancel() {
			this.$emit('cancel');
		}
	},
	computed: {
		isEnVersion() {
			return this.$store.getters.currentCulture === Culture.EN;
		}
	},
	watch: {
		value: function(val) {
			if (val) {
				this.model = new ScheduleTask(this.value);
			}
		}
	}
};
</script>

<style scoped>
/*input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }*/
</style>
